﻿import { GroupPermission, GetAllPermissionGroups, GetPermissionGroupsForUser, editUserGroupAssignments } from "../API/GroupPermissions/GroupPermissions";
import { RESTError } from "../API/RESTError";
import { UserAccountSet } from "../API/Users/UserAccountSet";
import { createNewUser, deleteUser, DigitalWeatherPermissions, getUsers, MetnetSpatialPermissions, updateUser } from "../API/Users/Users";
import { IHashData } from "../IHashData";
import { IPage } from "../IPage";
import { MainSite } from "../MainSite";
import { IRegion } from "../Model/Region";
import { UserAccount } from "../Model/UserAccount";
import { ManagePermissionGroupsPage } from "./GroupPermissions/ManagePermissionGroupsPage";

export class ManageUsersPage implements IPage {
    constructor(private mainSite: MainSite) {
    }

    public id: string = 'manageUsers';

    private navBarLink: JQuery;

    public initialize(): void {
    }

    private container: JQuery = null;
    private modal: JQuery = null;
    private modalContent: JQuery = null;

    private modalSaveButton: JQuery = null;

    private newUserPermissionContainer: JQuery = null;
    private newUserPermissionInput: JQuery = null;

    private newUserRegionContainer: JQuery = null;
    private newUserRegionInput: JQuery = null;

    private table: JQuery = null;
    private tableBody: JQuery = null;
    private tableHead: JQuery = null;
    private tableHeadRow: JQuery = null;

    private $noPermissionsWarningContainer: JQuery = null;
    private $noPermissionsWarningCheckbox: JQuery = null;


    public handleHashChange(hashData: IHashData): boolean {
        if (hashData.Page === this.id) {
            if (!this.container) {
                
                this.refresh();

            }
            return true;
        } else {
            if (this.modal) {
                this.modal.modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                this.modal.remove();
                this.modal = null;
            }
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }

    private userAccountSet: UserAccountSet = null;
    private allPermissionGroups: GroupPermission[] = [];

    private getUserData(callback: () => any): void {
        getUsers((err: any, data: UserAccountSet) => {
            if (!err) {                  
                this.userAccountSet = data;               
            }
            callback();
        });            
    }

    private refresh(): void {
        this.getUserData(() => {
            GetAllPermissionGroups((pErr: any, allGroups: GroupPermission[]) => {
                if (!pErr) {
                    this.allPermissionGroups = allGroups.sort((obj1, obj2) => {
                        if (obj1.GroupName.toLowerCase() > obj2.GroupName.toLowerCase()) {
                            return 1;
                        }

                        if (obj1.GroupName.toLowerCase() < obj2.GroupName.toLowerCase()) {
                            return -1;
                        }

                        return 0
                    });
                }
                this.renderManageUsers();
            });               
        });
    }

    private compare(a: any, b: any): any {
        if (a.email < b.email)
            return -1;
        if (a.email > b.email)
            return 1;
        return 0;
    }

    private renderManageUsers(): void {

        if (this.container) {
            this.container.remove();
            this.container = null;
        }

        this.container = $('<div class="container"></div>').appendTo('body')

        $('<h1 class="midi_manageUsersPage_title">Manage Users</h1>').appendTo(this.container);
        $('<button type="button" class="btn btn-success midi_manageUsersPage_createUserButton"><i class="fa fa-user-plus"></i> Pre-Approve Non-Shell User</button>')
                        .appendTo(this.container)
                        .click(() => {
                        this.renderModal(null, []);
            });

        var noneFound = $('<span class="empty-message">No users found.</span>');

        if (this.mainSite.currentUser.Permissions.GlobalAdministrator) {
            
            $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Global Administrator</strong>, you have <strong>full control</strong> of all users within the system.</p>').appendTo(this.container);
            $('<input id="midi_ManageUsersPage-search-input" class="form-control" type="text" placeholder="Search users by email, type or region" />').on('keyup input', (e) => {
                this.filterUsers($(e.target).val(),
                    this.container,
                    noneFound);
            }).appendTo(this.container);
            
        } else {
            var region: IRegion = this.mainSite.staticDataManager.Schema.RegionSet.Regions[this.mainSite.currentUser.Region];
            $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Regional Administrator</strong> for the <strong>' + region.Label + '</strong> region, you are able to pre-approve non-Shell users, or delete existing users, within your region.</p>').appendTo(this.container);
        }



        this.table = $('<table class="table table-striped table-hover midi_common_table"></table>').appendTo(this.container);
        this.tableBody = $('<tbody></tbody>').appendTo(this.table);
        this.tableHead = $('<thead></thead>').appendTo(this.table);
        this.tableHeadRow = $('<tr></tr>').appendTo(this.tableHead);
        $('<th>Email</th> <th>Type</th> <th>Region</th> <th>Registration Status</th> <th>Account Expiry</th> <th></th> <th></th>').appendTo(this.tableHeadRow);

        noneFound.appendTo(this.container).hide();

        var userObjectArray = [];

        for (var userId in this.userAccountSet.UserAccounts) {
            var user: UserAccount = this.userAccountSet.UserAccounts[userId];
            userObjectArray.push({ email: user.Id, user: user}); 
        }

        userObjectArray.sort(this.compare);

        userObjectArray.forEach(
            (userObj: { email: string; user: UserAccount}) => {

                var user: UserAccount = userObj.user;
                if (this.mainSite.currentUser.Permissions.GlobalAdministrator) {
                    // Carry on. Show all rows for Global Administrator.
                } else if (this.mainSite.currentUser.Region !== user.Region) {
                    // Display nothing if the user is not in their region
                    // This ensures that Admins will not see any Global Admins in the Manage Users page
                    return;
                }

                var tableCurrentRow = $('<tr></tr>')
                    .appendTo(this.tableBody);

                // write the user ID
                $('<td class="user_ID"></td>').text(user.Id).appendTo(tableCurrentRow);

                // Hard coded user types based on boolean permission settings
                var userType = 'Standard';
                if (user.Permissions.Administrator) {
                    userType = 'Administrator';
                }
                if (user.Permissions.GlobalAdministrator) {
                    userType = 'Global Administrator';
                }

                $('<td></td>').text(userType).appendTo(tableCurrentRow);

                // Write region, blank for Global Administrators

                var region: IRegion = this.mainSite.staticDataManager.Schema.RegionSet.Regions[user.Region];

                $('<td></td>').text(region ? region.Label : '').appendTo(tableCurrentRow);
                

                // Hard coded registration statuses based on approved boolean
                $('<td></td>').text((user.EmailConfirmed) ? 'Registered' : 'Pending Registration').appendTo(tableCurrentRow);

                var accountExpiry;
                if (user.ExpiryDate == 0) {
                    accountExpiry = "Account Never Expires";
                }
                else {
                    accountExpiry = moment(user.ExpiryDate).format("DD/MM/YYYY");
                }
                
                // write the account expiry
                $('<td></td>').text(accountExpiry).appendTo(tableCurrentRow);

                var deleteButtonCell = $('<td class="delete_user_button_cell" ></td>')
                    .appendTo(tableCurrentRow);

                var editButtonCell = $('<td class="edit_user_button_cell" ></td>')
                    .appendTo(tableCurrentRow);

                if (this.mainSite.currentUser.Id !== user.Id) { // don't let any user delete or edit themselves

                    // global admins can delete anyone
                    // regional admins can't delete other regional admins
                    if (this.mainSite.currentUser.Permissions.GlobalAdministrator || !user.Permissions.Administrator) {
                        $('<a class= "midi_common_link" > Delete User </a>')
                            .click(() => {
                                this.renderDeleteModal(user);
                        }).appendTo(deleteButtonCell);
                    }

                    // all admins are able to edit users which they can see
                    $('<a class= "midi_common_link">Edit User</a>')
                        .click(() => {
                            //get permissions groups for user before rendering modal
                            GetPermissionGroupsForUser(user.Id, (err: any, data: GroupPermission[]) => {
                                if (!err) {                                     
                                    var permissionGroupsForUser = data;
                                    this.renderModal(user, permissionGroupsForUser);
                                }                                  
                            });
                        
                    }).appendTo(editButtonCell);
                    
                }
            });
    }

    private accountExpiryDatePicker: JQuery;
    private userAccountExpiryCheckbox: JQuery;

    private metnetSpatialPermissionsContainer: JQuery;
    private digitalWeatherPermissionsContainer: JQuery;
    private userAccountExpiryContainer: JQuery;
    private modalBodyContent: JQuery;
    private userExpiryDate: number;

    private renderModal(user: UserAccount, groupPermissionsForUser: GroupPermission[]) {
        if (this.modal) {
            this.modal.remove();
            this.modal = null;
        }

        this.modal = $('<div class="modal fade"></div>')
            .appendTo('body');

        var modalDialog = $('<div class="modal-dialog"></div>')
            .appendTo(this.modal);

        var modalContent = $('<div class="modal-content"></div>')
            .appendTo(modalDialog);

        var modalHeaderContent = $('<div class="modal-header"></div>')
            .appendTo(modalContent);

        $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>')
            .appendTo(modalHeaderContent);

        if (!user) {
            $('<h4 class="modal-title">Pre-approve Non-Shell User</h4>')
                .appendTo(modalHeaderContent);
        } else {
            $('<h4 class="modal-title">Edit User</h4>')
                .appendTo(modalHeaderContent);
        }

        this.modalBodyContent = $('<div class="modal-body"></div>')
            .appendTo(modalContent);

        if (user) {
            $('<p>Please remember that users <strong>will not</strong> be alerted to any modifications which you make.<p>').appendTo(this.modalBodyContent);
        } else {
            $('<p>Please remember that users with an <strong>@shell.com</strong> email address are automatically pre-approved, and do not need to be created.<p>').appendTo(this.modalBodyContent);
            $('<p>This feature should only be used for pre-approving non-Shell users. Once pre-approved, they will be sent an <strong>automatically-generated email</strong> which will direct them to create an account on Shell ' + branding.siteName + '.<p>').appendTo(this.modalBodyContent);

            if (!this.mainSite.currentUser.Permissions.GlobalAdministrator) {
                var region: IRegion = this.mainSite.staticDataManager.Schema.RegionSet.Regions[this.mainSite.currentUser.Region];
                $('<p>User will be pre-approved as a <strong>Standard</strong> user, in the <strong>' + region.Label + '</strong> region.</p>').appendTo(this.modalBodyContent);
            }
        }

        var newUserEmailContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>')
            .appendTo(this.modalBodyContent);

        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-envelope-o fa-fw"></i></span>')
            .appendTo(newUserEmailContainer);

        this.newUserEmailInput = $('<input type="text" class="form-control" placeholder="Email address" aria-describedby="basic-addon1">')
            .appendTo(newUserEmailContainer);

        if (user) {
            this.newUserEmailInput.val(user.Id);
            this.newUserEmailInput.attr('active', 'false');
            this.newUserEmailInput.attr('readonly', 'readonly');
        }


        // START OF USER PERMISSIONS DROP-DOWN

        var updateUserPermissionContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>')
            .appendTo(this.modalBodyContent);

        $('<span class="input-group-addon" id="basic-addon1">User Type:</span>')
            .appendTo(updateUserPermissionContainer);

        var updateUserPermissionInput = $('<select class="form-control"></select>')
            .appendTo(updateUserPermissionContainer)
            .change(() => {
                if (updateUserPermissionInput.val() == 'Global Administrator') {
                    // hide the region picker box if we have selected Global Administrator permission
                    updateUserRegionContainer.hide();
                } else {
                    updateUserRegionContainer.show();
                }
            });

        $('<option>Standard</option>').appendTo(updateUserPermissionInput);

        // only Global Administrators can create / promote Administrators
        if (this.mainSite.currentUser.Permissions.GlobalAdministrator) {
            var administrator = $('<option>Administrator</option>').appendTo(updateUserPermissionInput);
            var globalAdministrator = $('<option>Global Administrator</option>').appendTo(updateUserPermissionInput);

            if (user && user.Permissions.GlobalAdministrator) {
                globalAdministrator.attr('selected', 'selected');
            } else if (user && user.Permissions.Administrator) {
                administrator.attr('selected', 'selected');
            }

        }

        // only Global Administrators can change permission
        if (!this.mainSite.currentUser.Permissions.GlobalAdministrator) {
            updateUserPermissionContainer.hide();
        }

        // START OF USER REGION DROP-DOWN

        var updateUserRegionContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>')
            .appendTo(this.modalBodyContent);

        $('<span class="input-group-addon" id="basic-addon1">User Management Region:</span>')
            .appendTo(updateUserRegionContainer);

        var updateUserRegionInput = $('<select class="form-control"></select>')
            .appendTo(updateUserRegionContainer);

        // only Global Administrators can change region
        if (!this.mainSite.currentUser.Permissions.GlobalAdministrator || (user && user.Permissions.GlobalAdministrator)) {
            updateUserRegionContainer.hide();
        }

        for (var regionId in this.mainSite.staticDataManager.Schema.RegionSet.Regions) {
            ((region: IRegion) => {
                if (this.mainSite.currentUser.Permissions.GlobalAdministrator || this.mainSite.currentUser.Region == region.Id) {
                    var regionOption = $('<option value="' + region.Id + '">' + region.Label + '</option>').appendTo(updateUserRegionInput);
                    if (user && user.Region === regionId) {
                        regionOption.attr('selected', 'selected');
                    }
                }
            })(this.mainSite.staticDataManager.Schema.RegionSet.Regions[regionId]);
        }

        var noRegionOption = $('<option value="No Region">No Region</option>').appendTo(updateUserRegionInput);
        if (user && !user.Region) {
            noRegionOption.attr('selected', 'selected');
        }

        this.userExpiryDate = null;

        this.userAccountExpiryCheckbox = $('<div class="midi_ManageUsersPage_input_container midi_ManageUsersPage_input_container_checkbox checkbox"><label><input id="accountExpiryCheck" type="checkbox" value="">Account Never Expires</label></div>')
            .appendTo(this.modalBodyContent)
            .change(() => {
            if ($("#accountExpiryCheck").prop('checked')) {
                    this.userAccountExpiryContainer.hide();
                    this.userExpiryDate = 0;
                } else {
                    this.userAccountExpiryContainer.show();
        }
            });

        this.renderAccountDatePicker();

        //Group permissions section - START
        var permissionGroupContainer = $('<div class="input-group midi_ManageUsersPage_permissiongroups_container"></div>').appendTo(this.modalBodyContent);
        var permissionHeaderConatiner = $('<div class="midi_ManageUsersPage_permission_header_conatiner"><strong>Permission Groups assigned to  user:</strong></div>').appendTo(permissionGroupContainer);
        var assignToNewGroupButton = $('<button type="button" class="btn btn-default" > Assign to Group</button>').appendTo(permissionHeaderConatiner);

        this.table = $('<table class="table table-striped table-hover midi_common_table"></table>').appendTo(permissionGroupContainer);
        this.tableBody = $('<tbody></tbody>').appendTo(this.table);
        this.tableHead = $('<thead></thead>').appendTo(this.table);
        this.tableHeadRow = $('<tr></tr>').appendTo(this.tableHead);
        $('<th>Group Name</th> <th>Permission</th><th></th>').appendTo(this.tableHeadRow);

        var noneFound = $('<span class="empty-message">No group permissions were assigned yet.</span>');
        noneFound.appendTo(permissionGroupContainer);
        this.renderPermissionGroupTable(noneFound, groupPermissionsForUser, assignToNewGroupButton);

        //: Hidden warning box with checkbox in case no permissions have been selected:
        this.$noPermissionsWarningContainer = $('<div class="alert alert-warning hidden" style="margin-top: 15px;"><p><strong>No Permission Groups were assigned to this User.</strong> This will cause the User not to be able to select Regions or Stations when they log in.<p><p>Are you sure you wish to proceed?</p></div>');
        this.$noPermissionsWarningCheckbox = $('<input type="checkbox">');
        this.$noPermissionsWarningContainer.append($('<p></p>').append($('<label> <span>Yes, proceed without assigning any Permission Groups to this User</span></label>').prepend(this.$noPermissionsWarningCheckbox)));

        assignToNewGroupButton.click(() => {
            this.$noPermissionsWarningContainer.addClass('hidden');
            this.$noPermissionsWarningCheckbox.prop('checked', false);

            var addNewRow = $('<tr><td></td><td></td></tr>').appendTo(this.tableBody);
            //permission group picker
            var permissionSelector = $('<td></td>').prependTo(addNewRow);

            var dropDown = $('<select class="form-control"></select>')
                .appendTo(permissionSelector);
            dropDown.append('<option value="" disabled selected><i>Select a Permission Group</i></option>');
            var assignedIds = groupPermissionsForUser.map(x => x.GroupId);
            this.allPermissionGroups.filter(x => assignedIds.indexOf(x.GroupId) == -1).forEach(pg => {
                if (groupPermissionsForUser.indexOf(pg) == -1) {
                    dropDown.append('<option value="' + pg.GroupId + '">' + pg.GroupName + '</option>');
                }
            });
            assignToNewGroupButton.prop('disabled', true);

            dropDown.on('change', (evt: any) => {
                this.$noPermissionsWarningContainer.addClass('hidden');
                this.$noPermissionsWarningCheckbox.prop('checked', false);

                var pg = this.allPermissionGroups.filter(x => x.GroupId == (evt.target.value + ""))[0];
                groupPermissionsForUser.push(pg);
                addNewRow.empty();
                this.renderPermissionGroupTable(noneFound, groupPermissionsForUser, assignToNewGroupButton);                    
            });
        });

        //Group permissions section - END       

        this.metnetSpatialPermissionsContainer = $('<div class="input-group midi_ManageUsersPage_input_container">METNET Spatial permissions:<br /></div>')
            .appendTo(this.modalBodyContent);

        $('<label class="midi_ManageUsersPage_input_container_checkbox_label"><input name="mns_permission" id="mns_permission_none" type="radio" value="0"> None</label>').appendTo(this.metnetSpatialPermissionsContainer);
        $('<label class="midi_ManageUsersPage_input_container_checkbox_label"><input name="mns_permission" id="mns_permission_user" type="radio" value="1"> User</label>').appendTo(this.metnetSpatialPermissionsContainer);
        $('<label class="midi_ManageUsersPage_input_container_checkbox_label"><input name="mns_permission" id="mns_permission_administrator" type="radio" value="2"> Administrator</label>').appendTo(this.metnetSpatialPermissionsContainer);


        this.digitalWeatherPermissionsContainer = $('<div class="input-group midi_ManageUsersPage_input_container">DigitalWeather permissions:<br /></div>')
            .appendTo(this.modalBodyContent);

        $('<label class="midi_ManageUsersPage_input_container_checkbox_label"><input name="dw_permission" id="dw_permission_none" type="radio" value="0"> None</label>').appendTo(this.digitalWeatherPermissionsContainer);
        $('<label class="midi_ManageUsersPage_input_container_checkbox_label"><input name="dw_permission" id="dw_permission_normal" type="radio" value="2"> Normal (released modules)</label>').appendTo(this.digitalWeatherPermissionsContainer);
        $('<label class="midi_ManageUsersPage_input_container_checkbox_label"><input name="dw_permission" id="dw_permission_beta" type="radio" value="1"> Beta (all modules)</label>').appendTo(this.digitalWeatherPermissionsContainer);

        this.$noPermissionsWarningContainer.appendTo(this.modalBodyContent);

        if (user) {

            $('#mns_permission_none').prop('checked', user.Permissions.MetnetSpatialPermissions == MetnetSpatialPermissions.None);
            $('#mns_permission_user').prop('checked', user.Permissions.MetnetSpatialPermissions == MetnetSpatialPermissions.User);
            $('#mns_permission_administrator').prop('checked', user.Permissions.MetnetSpatialPermissions == MetnetSpatialPermissions.Administrator);

            $('#dw_permission_none').prop('checked', user.Permissions.DigitalWeatherPermissions == DigitalWeatherPermissions.None);
            $('#dw_permission_beta').prop('checked', user.Permissions.DigitalWeatherPermissions == DigitalWeatherPermissions.User);
            $('#dw_permission_normal').prop('checked', user.Permissions.DigitalWeatherPermissions == DigitalWeatherPermissions.Essential);

            if (user.ExpiryDate == 0) {
                $('#accountExpiryCheck').prop('checked', true);
                this.userExpiryDate = 0;
                this.userAccountExpiryContainer.hide();
            } else {
                $('#midi_ManageUsersPage_expiry_date_picker').datepicker("setDate", new Date(user.ExpiryDate));
            }
        }
        else {
            $('#accountCSVCheck').prop('checked', true);
            $('#accountDLPCheck').prop('checked', true);
        }

        var modalFooterContent = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal" > Close </button>').appendTo(modalFooterContent);
        this.modalSaveButton = $('<button type="button" class="btn btn-success" > Submit</button>')
            .appendTo(modalFooterContent)
            .click(() => {

            $('.midi_ManageUsersPage_warningBox').remove();

            var setRegion: string = (updateUserRegionInput.val() == 'No Region') ? null : updateUserRegionInput.val();


            var userPermissionUpdate = updateUserPermissionInput.val();

            var setAdmin: boolean = userPermissionUpdate == "Administrator";
            var setGlobalAdmin: boolean = userPermissionUpdate == "Global Administrator";

                var metnetSpatialPermissions: MetnetSpatialPermissions = $('input[name="mns_permission"]:checked').val();
                var digitalWeatherPermissions: DigitalWeatherPermissions = $('input[name="dw_permission"]:checked').val();

            if (groupPermissionsForUser.length == 0 && !this.$noPermissionsWarningCheckbox.prop('checked')) {
                this.$noPermissionsWarningContainer.removeClass('hidden');
                return;
            }

            if (!user) {
                var setEmail = this.newUserEmailInput.val();

                if (this.validateNewUser(setEmail, this.modalBodyContent) && this.validateChangeUser(setGlobalAdmin, setAdmin, setRegion, this.modalBodyContent)) {
                    createNewUser(setEmail, setRegion, setAdmin, setGlobalAdmin, metnetSpatialPermissions, digitalWeatherPermissions, this.userExpiryDate,(err: RESTError) => {
                        if (err) {
                            $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Creating User: ' + err.Message + '</div>').appendTo(this.modalBodyContent);
                            return;
                        }
                        //Save permission groups
                        editUserGroupAssignments({ UserId: setEmail, GroupIds: groupPermissionsForUser.map(gp => gp.GroupId) }, (pErr: RESTError) => {
                            if (pErr) {
                                $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Creating User: ' + err.Message + '</div>').appendTo(this.modalBodyContent);
                                return;
                            }
                            this.modal.modal('hide');
                            if (this.pastExpiryWarningText) {
                                this.pastExpiryWarningText.remove();
                                this.pastExpiryWarningText = null;
                            }
                            this.refresh();
                        });
                    });
                }
            }
            else {
                this.removePreviousErrors();
                if (this.validateAccountExpiry(this.modalBodyContent) && this.validateChangeUser(setGlobalAdmin, setAdmin, setRegion, this.modalBodyContent)) {
                    updateUser(user.Id, setRegion, setAdmin, setGlobalAdmin, metnetSpatialPermissions, digitalWeatherPermissions, this.userExpiryDate,(err: RESTError) => {
                        if (err) {
                            $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Creating User: ' + err.Message + '</div>').appendTo(this.modalBodyContent);
                            return;
                        }
                        //Update permission groups
                        editUserGroupAssignments({ UserId: user.Id, GroupIds: groupPermissionsForUser.map(gp => gp.GroupId) }, (pErr: RESTError) => {
                            if (pErr) {
                                $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Creating User: ' + err.Message + '</div>').appendTo(this.modalBodyContent);
                                return;
                            }
                            this.modal.modal('hide');
                            if (this.pastExpiryWarningText) {
                                this.pastExpiryWarningText.remove();
                                this.pastExpiryWarningText = null;
                            }
                            this.refresh();
                        });                          
                    });
                }
            }
        });          

        this.modal.modal('show');     
    }

    private renderPermissionGroupTable(noneFound: JQuery, groupPermissionsForUser: GroupPermission[], assignToNewGroupButton: JQuery) {
        this.tableBody.empty();
        assignToNewGroupButton.prop('disabled', false);
        if (groupPermissionsForUser.length == 0) {
            noneFound.show();
        } else {
            noneFound.hide();
            groupPermissionsForUser.forEach(gp => {
                var tr = $('<tr></tr>').appendTo(this.tableBody);
                $('<td>' + gp.GroupName + '</td>').appendTo(tr);
                $('<td>' + ManagePermissionGroupsPage.getGroupPermissionTypeName(gp.GroupPermissionType) + '</td>').appendTo(tr);
                $('<td><i class="fa fa-fw fa-times"></i></td>').click(() => {
                    this.$noPermissionsWarningContainer.addClass('hidden');
                    this.$noPermissionsWarningCheckbox.prop('checked', false);

                    groupPermissionsForUser.splice(groupPermissionsForUser.indexOf(gp), 1);
                    this.renderPermissionGroupTable(noneFound, groupPermissionsForUser, assignToNewGroupButton);
                }).appendTo(tr);
            });
        }
    }
                
    private renderDeleteModal(user: UserAccount) {
        if (this.modal) {
            this.modal.remove();
            this.modal = null;
        }

        this.modal = $('<div id="myModal" class="modal fade" ></div>')
            .appendTo('body');

        var modalDialog = $('<div class="modal-dialog"></div>').appendTo(this.modal);

        var modalContent = $('<div class="modal-content"></div>')
            .appendTo(modalDialog);

        var modalHeaderContent = $('<div class="modal-header"></div>')
            .appendTo(modalContent);

        $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>')
            .appendTo(modalHeaderContent);

        $('<h4 class="modal-title">Confirm Delete</h4>')
            .appendTo(modalHeaderContent);

        var modalBodyContent = $('<div class="modal-body"></div>')
            .appendTo(modalContent);

        $('<p>Are you sure you want to delete <strong>' + user.Id + '</strong> from the system?<p>').appendTo(modalBodyContent);

        var modalFooterContent = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal" > Cancel </button>').appendTo(modalFooterContent);
        this.modalSaveButton = $('<button type="button" class="btn btn-success" > Delete</button>')
            .click(() => {

                deleteUser(user.Id, (err: RESTError) => {
                    if (err) {
                        $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Deleting User: ' + err.Message + '</div>').appendTo(modalBodyContent);
                        return;
                    }
                    this.modal.modal('hide');
                    this.refresh();
                });
            })
            .appendTo(modalFooterContent);

        this.modal.modal('show');     
    }

    

    private renderAccountDatePicker(): void {
        this.userAccountExpiryContainer = $('<div class="input-group midi_ManageUsersPage_input_container" style="padding-top: 0;"></div>')
            .appendTo(this.modalBodyContent);
        $('<div class="panel panel-default"><div class="panel-body">Please note that the user account will expire at <strong>00:00 UTC</strong> on the selected expiry date.</div></div>').appendTo(this.userAccountExpiryContainer);
        var accountExpiryDatePickerContainer = $('<div class="input-group"></div>').appendTo(this.userAccountExpiryContainer);
        $('<span class="input-group-addon" id="basic-addon2"><i class="fa fa-calendar fa-fw"></i></span>').appendTo(accountExpiryDatePickerContainer);
        this.accountExpiryDatePicker = $('<input class="input-sm form-control" placeholder="Account expiry date" type="text" id="midi_ManageUsersPage_expiry_date_picker" aria-describedby="basic-addon2"></input>')
            .appendTo(accountExpiryDatePickerContainer)
            .datepicker({
            format: "yyyy-mm-dd"
        })
            .on('changeDate',() => {
            this.userExpiryDate = moment.utc(this.accountExpiryDatePicker.val(), 'YYYY-MM-DD').valueOf();
        });
    }

    
    private newUserEmailInput: JQuery = null;
    private validationErrorText: JQuery = null;
    private pastExpiryWarningText: JQuery = null;

    private validateChangeUser(globalAdmin: boolean, admin: boolean, region: string,  modalBodyContent: JQuery): boolean {
        if (admin && region === null) {
            this.validationErrorText = $('<div class="alert alert-danger midi_ManageUsersPage_warningBox"><i class="fa fa-exclamation-triangle"></i> Administrators must be assigned a region.</div>').appendTo(modalBodyContent);
            return false;
        }

        return true;
    }

    private validateNewUser(email: string, modalBodyContent: JQuery): boolean {
        //currently allows up to xx@icon.software (NB {2,8} length for the .something part
        var validEmailFormatRegex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,8}(?:\.[a-z]{2})?)$/i;

        this.removePreviousErrors();

        if (!validEmailFormatRegex.test(email)) {
            this.validationErrorText = $('<div class="alert alert-danger midi_ManageUsersPage_warningBox"><i class="fa fa-exclamation-triangle"></i> Please enter a valid email address.</div>').appendTo(modalBodyContent);
            this.newUserEmailInput.addClass("midi_common_validation_warning");
            return false;
        }

        return this.validateAccountExpiry(modalBodyContent);

    }

    private removePreviousErrors(): void {
        if (this.validationErrorText) {
            this.validationErrorText.remove();
            this.newUserEmailInput.removeClass("midi_common_validation_warning");
        }
    }

    private validateAccountExpiry(modalBodyContent: JQuery): boolean {
        if (!$("#accountExpiryCheck").prop('checked') && $('#midi_ManageUsersPage_expiry_date_picker').val() == "") {
            this.validationErrorText = $('<div class="alert alert-danger midi_ManageUsersPage_warningBox"><i class="fa fa-exclamation-triangle"></i> Please enter a valid expiry date or select <strong>Account Never Expires</strong>.</div>').appendTo(modalBodyContent);
            this.accountExpiryDatePicker.addClass("midi_common_validation_warning");
            return false;
        }
        if (this.userExpiryDate >= moment.utc().valueOf()) {
            if (this.pastExpiryWarningText) {
                this.pastExpiryWarningText.remove();
                this.pastExpiryWarningText = null;
            }
        }

        if (!$("#accountExpiryCheck").prop('checked') && !this.pastExpiryWarningText && this.userExpiryDate < moment.utc().valueOf()) {
            this.pastExpiryWarningText = $('<div class="alert alert-danger midi_ManageUsersPage_warningBox"><i class="fa fa-exclamation-triangle"></i> Warning account expiry already past, please submit again to confirm.</div>').appendTo(modalBodyContent);
            return false;
        }
        return true;
    }

    private filterUsers(searchString: string,
        container: JQuery,
        noneFound: JQuery) {
        searchString = searchString.toLowerCase().replace(/\s/g, "");
        var found = 0;

        for (var i = 0; i < container.find('tbody').eq(0).find('tr').length; i++) {
            let tableRow = container.find('tbody').eq(0).find('tr').eq(i);
            const email = tableRow.find('td').eq(0).text();
            const type = tableRow.find('td').eq(1).text();
            const region = tableRow.find('td').eq(2).text();

            if (email.toLowerCase().replace(/\s/g, "").indexOf(searchString) > -1 ||
                type.toLowerCase().replace(/\s/g, "").indexOf(searchString) > -1 ||
                region.toLowerCase().replace(/\s/g, "").indexOf(searchString) > -1) {
                found++;
                tableRow.show();
            } else {
                tableRow.hide();
            }
            if (found === 0) {
                noneFound.show();
            }
            else {
                noneFound.hide();
            }

        }          
    }
}